/**
 * pages.config.js - Page routing configuration
 * 
 * This file is AUTO-GENERATED. Do not add imports or modify PAGES manually.
 * Pages are auto-registered when you create files in the ./pages/ folder.
 * 
 * THE ONLY EDITABLE VALUE: mainPage
 * This controls which page is the landing page (shown when users visit the app).
 * 
 * Example file structure:
 * 
 *   import HomePage from './pages/HomePage';
 *   import Dashboard from './pages/Dashboard';
 *   import Settings from './pages/Settings';
 *   
 *   export const PAGES = {
 *       "HomePage": HomePage,
 *       "Dashboard": Dashboard,
 *       "Settings": Settings,
 *   }
 *   
 *   export const pagesConfig = {
 *       mainPage: "HomePage",
 *       Pages: PAGES,
 *   };
 * 
 * Example with Layout (wraps all pages):
 *
 *   import Home from './pages/Home';
 *   import Settings from './pages/Settings';
 *   import __Layout from './Layout.jsx';
 *
 *   export const PAGES = {
 *       "Home": Home,
 *       "Settings": Settings,
 *   }
 *
 *   export const pagesConfig = {
 *       mainPage: "Home",
 *       Pages: PAGES,
 *       Layout: __Layout,
 *   };
 *
 * To change the main page from HomePage to Dashboard, use find_replace:
 *   Old: mainPage: "HomePage",
 *   New: mainPage: "Dashboard",
 *
 * The mainPage value must match a key in the PAGES object exactly.
 */
import React from 'react';
const Analytics = React.lazy(() => import('./pages/Analytics'));
const Credits = React.lazy(() => import('./pages/Credits'));
const ReportBug = React.lazy(() => import('./pages/ReportBug'));
const Dashboard = React.lazy(() => import('./pages/Dashboard'));
const DesignEditor = React.lazy(() => import('./pages/DesignEditor'));
const DevLogin = React.lazy(() => import('./pages/DevLogin'));
const DevPortal = React.lazy(() => import('./pages/DevPortal'));
const Generate = React.lazy(() => import('./pages/Generate'));
const GenerateAudio = React.lazy(() => import('./pages/GenerateAudio'));
const GenerateThumbnails = React.lazy(() => import('./pages/GenerateThumbnails'));
const GenerateVideos = React.lazy(() => import('./pages/GenerateVideos'));
const Help = React.lazy(() => import('./pages/Help'));
const ImageEditor = React.lazy(() => import('./pages/ImageEditor'));
const Landing = React.lazy(() => import('./pages/Landing'));
const Marketplace = React.lazy(() => import('./pages/Marketplace'));
const MyAssets = React.lazy(() => import('./pages/MyAssets'));
const SellerDashboard = React.lazy(() => import('./pages/SellerDashboard'));
const Settings = React.lazy(() => import('./pages/Settings'));
const SocialHub = React.lazy(() => import('./pages/SocialHub'));
const AIAvatars = React.lazy(() => import('./pages/AIAvatars'));
const BrandKit = React.lazy(() => import('./pages/BrandKit'));
const Carousel = React.lazy(() => import('./pages/Carousel'));
const CompetitorAnalysis = React.lazy(() => import('./pages/CompetitorAnalysis'));
const ContentCalendar = React.lazy(() => import('./pages/ContentCalendar'));
const Templates = React.lazy(() => import('./pages/Templates'));
const Team = React.lazy(() => import('./pages/Team'));
const AcceptInvite = React.lazy(() => import('./pages/AcceptInvite'));
const AdminDashboard = React.lazy(() => import('./pages/AdminDashboard'));
import __Layout from './Layout.jsx';


export const PAGES = {
    "Analytics": Analytics,
    "Credits": Credits,
    "ReportBug": ReportBug,
    "Dashboard": Dashboard,
    "DesignEditor": DesignEditor,
    "DevLogin": DevLogin,
    "DevPortal": DevPortal,
    "Generate": Generate,
    "GenerateAudio": GenerateAudio,
    "GenerateThumbnails": GenerateThumbnails,
    "GenerateVideos": GenerateVideos,
    "Help": Help,
    "ImageEditor": ImageEditor,
    "Landing": Landing,
    "Marketplace": Marketplace,
    "MyAssets": MyAssets,
    "SellerDashboard": SellerDashboard,
    "Settings": Settings,
    "SocialHub": SocialHub,
    "AIAvatars": AIAvatars,
    "BrandKit": BrandKit,
    "Carousel": Carousel,
    "CompetitorAnalysis": CompetitorAnalysis,
    "ContentCalendar": ContentCalendar,
    "Templates": Templates,
    "Team": Team,
    "AcceptInvite": AcceptInvite,
    "AdminDashboard": AdminDashboard,
}

export const pagesConfig = {
    mainPage: "Landing",
    Pages: PAGES,
    Layout: __Layout,
};